import { SvgIcon } from "@mui/material";
import React from "react";

const SupplierIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 -58 512 512">
			<svg>
				<g fill="rgba(0, 0, 0, 0.54)" fillRule="evenodd">
					<path d="m267 235.395-43.418-10.872c-5.621-1.402-11.793.555-15.516 5.465l-32.89 43.344-32.953-43.422c-3.47-4.91-9.723-7.433-15.899-5.86l-51.867 13.294C30.157 248.699 0 287.524 0 333.188v46.734c0 8.285 6.715 15 15 15h254.535A44.926 44.926 0 0 1 267 380zm144.273-24.77 9.125 4.586V180h-31.605v35.21l9.035-4.538a14.907 14.907 0 0 1 13.445-.047zm0 0" />
					<path d="M497 180h-46.605v59.465c0 8.285-6.715 15-15 15-2.918 0-5.645-.836-7.95-2.281l-22.851-11.48-24.121 12.12c-10.043 5.035-21.63-2.492-21.621-13.36L358.789 180H312c-8.285 0-15 6.719-15 15v185c0 8.285 6.715 15 15 15h185c8.285 0 15-6.715 15-15V195c0-8.285-6.715-15-15-15zm-220.828-79c0 55.781-45.219 101-101 101s-101-45.219-101-101 45.219-101 101-101 101 45.219 101 101zm0 0" />
				</g>
			</svg>
		</SvgIcon>
	);
};
export default SupplierIcon;
